import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    READ_PERMISSION,
    UPDATE_PERMISSION,
    CREATE_PERMISSION,
    STORE_AUTH,
    STORE_INTEGRATIONS_STATUS_AUTH,
    STORE_GOALS_AUTH,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/management/agency-goals',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_GOALS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/store/AgencyGoalsView')),
    },
    {
        exact: true,
        path: '/management/store-integrations',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_INTEGRATIONS_STATUS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() =>
            import('src/views/store/StoreIntegrationsView')
        ),
    },
    {
        exact: true,
        path: '/create/store',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/store/StoreCreateView')),
    },
    {
        exact: true,
        path: '/management/stores/:id',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/store/StoreDetailsView')),
    },
    {
        exact: true,
        path: '/management/stores/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/store/StoreEditView')),
    },
    {
        exact: true,
        path: '/management/stores',
        guard: PermissionsGuard,
        roles: {
            permission: STORE_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/store/StoreListView')),
    },
];
